import { render, staticRenderFns } from "./CredorList.vue?vue&type=template&id=32fbc380&scoped=true&"
import script from "./CredorList.vue?vue&type=script&lang=js&"
export * from "./CredorList.vue?vue&type=script&lang=js&"
import style0 from "./CredorList.vue?vue&type=style&index=0&id=32fbc380&lang=scss&scoped=true&"
import style1 from "./CredorList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbc380",
  null
  
)

export default component.exports